
<template>
<v-layout>
  <v-flex offset-xs3 xs6>
    <v-progress-linear :value="progress" height="5" color="accent"></v-progress-linear>
  </v-flex>
  <v-flex class="pb-0 pt-2 mt-2" xs1 text-xs-left>
    <span class="accent--text">{{progress}}%</span>
  </v-flex>
</v-layout>
</template>

<script>
import {
  eventBus
} from '../main';
export default {
  computed: {
    progress() {
      var thisPgProgress = Math.round(100 * this.pages.indexOf(this.value) / (this.pages.length - 1));
      var parentProgress = this.$parent.progress ? this.$parent.progress : 0;
      var maxProgress = Math.max(thisPgProgress, parentProgress);
      this.$parent.progress = maxProgress;
      return maxProgress;
    }
  },
  props: ['value'],
  name: 'lesson_progress',
  data() {
    return {
      pages: ["page0-1",
        "page1-1",
        "page1-2",
        "page1-3",
        "page1-4",
        "page1-5",
        "page1-6",
        "page1-7",
        "page2-1",
        "page3-1",
        "page3-2",
        "page3-3",
        "page4-1",
        "page4-2",
        "page5-1",
        "page6-1",
        "page6-2",
        "page6-3",
        "page6-4",
        "page6-5",
        "page6-6",
        "page6-7",
        "page6-8",
        "page6-9",
        "page6-10",
        "page6-11",
        "page6-12",
        "page6-13",
        "page6-14",
        "page6-15",
        "page6-16",
        "page6-17",
        "page6-18",
        "page6-19",
        "page6-20",
        "page7-1",
        "page7-2",
        "page8-1",
        "page8-2",
        "page8-3",
        "page8-4",
        "page9-1",
        "page10-1",
        "page10-2",
        "page10-3",
        "page10-4",
        "page10-5",
        "page10-6",
        "page10-7",
      ]
    }
  }
};
</script>
